import MappingIcon from '@material-ui/icons/Map';

const Mappings = {
    icon: MappingIcon,
};

export default Mappings;
